<script setup>
import { formattedDate, humanizeText } from '@/helper';
import { parse_notification_response, swalError } from '@/helper'
import { get_notifications } from '@/services/notifications';
import { onMounted, ref } from 'vue';
import notificationList  from '@/components/notificationList.vue'

const activities = ref([])
const isLoading = ref(true)
onMounted(async()=>{
  await fetch_notification()
  isLoading.value = false
})

async function fetch_notification(){
  let params = {
    limit: 3,
    type: 'unread'
  }
  let response = await get_notifications(params)
  if (response.error){
    swalError(response.result, true)
    return
  }
  activities.value = parse_notification_response(
    response.result.data.data, 
    response.result.data.included
  )
}
</script>

<template>
  <div class="card height-equal first-row">
    <div class="card-header card-no-border">
      <div class="header-top">
        <h5 class="m-0">Activity</h5>
        <div class="d-flex justify-content-center align-content-center">
          <router-link :to="{name: 'activity'}" class="btn btn-light-primary py-1">
            View More
          </router-link>
        </div>
      </div>
    </div>
    <template v-if="isLoading">
      <div class="card-body">
        <loadingCard loadingType="list"/>
      </div> 
    </template>
    <div v-else class="card-body pt-0">
      <template v-if="activities.length == 0">
        <div class="center-card">
          <emptyCard text="No new notification at the moment" :needLink="false"/>
        </div>
      </template>
      <ul v-else class="h-test">
        <li class="d-flex" v-for="item in activities" :key="item">
          <notificationList :notification="item" />
        </li>
      </ul>
    </div>
  </div>
</template>
